<template>
  <owal-modal-panel
    :title="title"
    :bottom-buttons="buttons"
    presentation-style="form"
    @button-click="handleButton"
    >
    <owal-form
      ref="form"
      :form="inputForm"
      :initial-submission="initialSubmission"
      :embedded="true"
      @change="updateButtons"
      @submit-end="handleSubmit"
      :metadata="metadata"
      :submittingOverride="submitting"
      @submit-start="submitIdentity"
      />
  </owal-modal-panel>
</template>

<script>
import OwalForm from '@/libraries/owal-ui/forms/OwalForm'
import OwalModalPanel from '@/libraries/owal-ui/panels/OwalModalPanel'
import * as profiles from '@/libraries/user-management'
import { mapGetters } from 'vuex'
import { createNewIdentity, editIdentity } from '@/libraries/api/credentialMismatch'

export default {
  name: 'EditIdentityPanel',
  components: { OwalForm, OwalModalPanel },
  props: {
    identityToEdit: {
      type: Object,
      default: () => {},
      required: false,
    },
    initialImage: {
      default: undefined,
      required: false,
    },
  },
  data () {
    return {
      readyToSubmit: false,
      inputForm: profiles.addCredential,
      submitting: false,
    }
  },
  computed: {
    ...mapGetters(['currentDomainUUID']),
    metadata () {
      return {
        domain_uuid: this.currentDomainUUID,
      }
    },
    title () {
      return this.identityToEdit ? 'Edit Identity' : 'Add Identity'
    },
    endpoint () {
      let endpoint = '/api/api/api/v8/faces'
      if (this.identityToEdit) {
        const uuid = this.identityToEdit.frontend_face_uuid
        if (uuid) {
          endpoint = `${endpoint}/${uuid}`
        }
      }
      return endpoint
    },
    initialSubmission () {
      let identity = Object.assign({}, this.identityToEdit)

      if (this.initialImage) {
        identity.image = this.initialImage
      }

      if (identity.role) {
        identity.tor = this.identityToEdit.role.toLowerCase() === 'tor'
      }

      if (identity.name && !identity.first_name) {
        const split = this.identityToEdit.name.split(/\s+/)
        const parts = split.filter(part => part !== '')
        if (parts.length < 2) {
          identity.first_name = parts[0]
        } else if (parts.length < 3) {
          identity.first_name = parts[0]
          identity.last_name = parts[1]
        } else if (parts.length < 4) {
          identity.first_name = `${parts[0]} ${parts[1]}`
          identity.last_name = parts[2]
        } else {
          identity.first_name = `${parts[0]} ${parts[1]}`
          identity.last_name = parts.reduce((lastName, currentPart, index) => {
            if (index > 1) {
              lastName += `${currentPart} `
              return lastName
            } else return ''
          }, '')
        }
      }

      if (identity.credentials) {
        const credentialIds = identity.credentials.map(credential => credential.credential_number)
        identity.credentials = credentialIds
      }

      const submission = this.inputForm.initializationTemplate.processSubmission(identity)
      // console.log(`Submission: ${JSON.stringify(submission, null, 2)}`)
      // console.log(`Face: ${JSON.stringify(face, null, 2)}`)
      return submission
    },
    buttons: function () {
      let buttons = [{
        title: 'cancel',
        identifier: 'close',
      }]

      if (this.readyToSubmit) {
        buttons.push({
          title: 'Save',
          identifier: 'save',
        })
      }

      return buttons
    },
  },
  methods: {
    handleSubmit: function ({ submission, endpoint, response, success, error }) {
      let uuid = ''
      if (response && response.data) {
        uuid = response.data.frontend_face_uuid
      }
      this.closeWindow(success, uuid)
    },
    handleButton (identifier) {
      if (identifier === 'close') {
        this.closeWindow(false) // Cancel button
      } else if (identifier === 'save') {
        this.$refs.form.submit()
      }
    },
    closeWindow (didSubmit, result) {
      const identity = this.identityToEdit
      const isEdit = !!identity
      const action = isEdit ? 'edit' : 'add'

      let payload = {
        success: didSubmit,
        action,
        result,
      }
      this.$emit('close', payload)
    },
    updateButtons: function (submission) {
      this.readyToSubmit = this.inputForm.validateSubmission(submission)
    },
    submitIdentity (form) {
      const identityForSubmission = Object.assign({}, form.identity_info, { domain_uuid: form.domain_uuid })
      const images = !!(this.initialImage && identityForSubmission.image)
      const sameImage = images && !!(identityForSubmission.image.data_b64 === identityForSubmission.image.i_b64)
      if (images && sameImage) {
        identityForSubmission.image = this.identityToEdit.imageURL
      } else if (images && this.identityToEdit.imageURL) {
        identityForSubmission.image = identityForSubmission.image.data_b64
        identityForSubmission.image_delete_key = this.identityToEdit.imageURL.match(/keycard\/dom-.*/)[0]
      } else if (identityForSubmission.image) {
        identityForSubmission.image = identityForSubmission.image.data_b64
      } else if (this.initialImage && !images) {
        identityForSubmission.image_delete_key = this.identityToEdit.imageURL.match(/keycard\/dom-.*/)[0]
      }
      if (this.identityToEdit) {
        editIdentity(identityForSubmission, this.identityToEdit.identityId).then(function (result) {
          this.submitting = false
          const newProfile = Object.assign({}, identityForSubmission, result.data.info[0])
          this.closeWindow(true, newProfile)
        }.bind(this)).catch(error => {
          alert(error)
        })
      } else {
        createNewIdentity(identityForSubmission).then(function (result) {
          this.submitting = false
          this.closeWindow(true, '')
        }.bind(this)).catch(error => {
          alert(error)
        })
      }
    },
  },
}
</script>

<style scoped>

</style>
